<template>
    <div data-backdrop="static" data-keyboard="false" class="modal fade" id="bookseller-form-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title page-title" v-html="modalTitle"/>
                </div>
                <form @submit.prevent="submit()" class="form-horizontal">
                    <div class="modal-body">
                        <div class="row form-group">
                            <label for="bookseller-email" class="col-2 control-label">
                                <span v-html="$t('BooksellerFormModal.email')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-10">
                                <input id="bookseller-email" :placeholder="$t('BooksellerFormModal.required')" type="email"
                                       ref="emailInput" :disabled="mode === 'edit'" class="form-control"
                                       required v-model="bookseller.email"/>
                            </div>
                        </div>
                        <div v-if="hermesShop.type === 'B2C'" class="row form-group">
                            <label for="bookseller-first-name" class="col-6 control-label">
                                <span v-html="$t('BooksellerFormModal.firstName')"/>
                                <RedAsterisk/>
                            </label>
                            <label for="bookseller-last-name" class="col-6 control-label">
                                <span v-html="$t('BooksellerFormModal.lastName')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-6">
                                <input id="bookseller-first-name" :placeholder="$t('BooksellerFormModal.required')"
                                       class="form-control" required v-model="bookseller.firstName"/>
                            </div>
                            <div class="col-6">
                                <input id="bookseller-last-name" :placeholder="$t('BooksellerFormModal.required')"
                                       class="form-control" required v-model="bookseller.lastName"/>
                            </div>
                        </div>
                        <div class="row form-group" v-else>
                            <label for="bookseller-society" class="col-2 control-label">
                                <span v-html="$t('BooksellerFormModal.society')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-10">
                                <input id="bookseller-society" :placeholder="$t('BooksellerFormModal.required')"
                                       class="form-control" required v-model="bookseller.society"/>
                            </div>
                        </div>
                        <div v-if="mode === 'create'" class="row form-group">
                            <label for="bookseller-password" class="col-6 control-label">
                                <span v-html="$t('BooksellerFormModal.password')"/>
                                <RedAsterisk/>
                            </label>
                            <label for="bookseller-confirm-password" class="col-6 control-label">
                                <span v-html="$t('BooksellerFormModal.confirmPassword')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-6">
                                <input id="bookseller-password" minlength="5" :placeholder="$t('BooksellerFormModal.required')"
                                       class="form-control" type="password" required v-model="bookseller.password"/>
                            </div>
                            <div class="col-6">
                                <input id="bookseller-confirm-password" minlength="5" :placeholder="$t('BooksellerFormModal.required')"
                                       class="form-control" type="password" required v-model="confirmPassword"/>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row form-group">
                                <label for="bookseller-is-admin" class="col-6 control-label" v-html="$t('BooksellerFormModal.isAdmin')"/>
                                <label for="bookseller-active" class="col-6 control-label" v-html="$t('BooksellerFormModal.active')"/>
                                <div class="col-6">
                                    <ToggleButton id="bookseller-is-admin" :value="bookseller.isAdmin" :sync="true" v-model="bookseller.isAdmin"/>
                                </div>
                                <div class="col-6">
                                    <ToggleButton id="bookseller-active" :value="bookseller.active" :sync="true" v-model="bookseller.active"/>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label for="bookseller-mobile-phone" class="col-6 control-label" v-html="$t('BooksellerFormModal.mobilePhone')"/>
                                <label for="bookseller-default-discount" class="col-6 control-label">
                                    <span v-html="$t('BooksellerFormModal.defaultDiscount')"/>
                                    <InfoCircle :tooltip="$t('BooksellerFormModal.defaultDiscountWillApplyOnAllProducts')"/>
                                </label>
                                <div class="col-6">
                                    <input id="bookseller-mobile-phone" :placeholder="$t('BooksellerFormModal.optional')"
                                           class="form-control" type="tel" v-model="bookseller.mobilePhone"/>
                                </div>
                                <div class="col-6 input-group">
                                    <input id="bookseller-default-discount" :placeholder="$t('BooksellerFormModal.optional')"
                                           min="0" max="100" class="form-control" type="number" step="0.01"
                                           v-model="bookseller.discounts.default"/>
                                    <div class="input-group-append">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer flex justify-content-between">
                        <button :disabled="loading" type="button" class="btn btn-secondary" data-dismiss="modal" v-html="$t('BooksellerFormModal.close')"/>
                        <SubmitBtn classes="btn btn-primary" :text="modalMainAction" :loading="loading"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import SubmitBtn from "../../forms/SubmitBtn";
import Bookseller from "../../../../classes/Distribution/Bookseller/Bookseller";
import RedAsterisk from "../../forms/RedAsterisk";
import {mapGetters} from "vuex";
import InfoCircle from "../../misc/InfoCircle";

export default {
    name: "BooksellerFormModal",
    components: {InfoCircle, RedAsterisk, SubmitBtn},
    data() {
        return {
            loading: false,
            bookseller: new Bookseller(),
            mode: "create",
            confirmPassword: "",
        };
    },
    computed: {
        ...mapGetters("hermesAPIConfig", {
            hermesShop: "shop",
        }),
        modalTitle() {
            return this.mode === "create" ? this.$t("BooksellerFormModal.addBookseller") : this.$t("BooksellerFormModal.editBookseller");
        },
        modalMainAction() {
            return this.mode === "create" ? this.$t("BooksellerFormModal.add") : this.$t("BooksellerFormModal.edit");
        },
    },
    methods: {
        show(bookseller = null) {
            this.mode = bookseller === null ? "create" : "edit";
            this.bookseller = new Bookseller(bookseller);
            this.confirmPassword = "";
            // eslint-disable-next-line no-undef
            $("#bookseller-form-modal").modal("show");
            if (this.mode === "create") {
                setTimeout(() => this.$refs.emailInput.focus(), 500);
            }
        },
        async submit() {
            try {
                this.loading = true;
                if (this.mode === "create") {
                    await this.submitCreate();
                } else if (this.mode === "edit") {
                    await this.submitEdit();
                }
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
        async submitCreate() {
            if (this.bookseller.password !== this.confirmPassword) {
                return this.$toasted.error(this.$t("BooksellerFormModal.passwordsDontMatch"), { icon: "lock" });
            }
            const { data } = await this.$hermesAPI.postBookseller(this.bookseller);
            this.$emit("addBookseller", data.user);
            // eslint-disable-next-line no-undef
            $("#bookseller-form-modal").modal("hide");
            this.$toasted.success(this.$t("BooksellerFormModal.booksellerAdded"), { icon: "check" });
        },
        async submitEdit() {
            const { data } = await this.$hermesAPI.patchBookseller({ ...this.bookseller, defaultDiscount: this.bookseller.discounts.default });
            this.$emit("editBookseller", data);
            // eslint-disable-next-line no-undef
            $("#bookseller-form-modal").modal("hide");
            this.$toasted.success(this.$t("BooksellerFormModal.booksellerEdited"), { icon: "check" });
        },
    },
};
</script>

<style scoped>

</style>